// Do not edit.
import { ShaderStore } from "../Engines/shaderStore";
import { bonesDeclaration } from "./ShadersInclude/bonesDeclaration";
import { bakedVertexAnimationDeclaration } from "./ShadersInclude/bakedVertexAnimationDeclaration";
import { clipPlaneVertexDeclaration } from "./ShadersInclude/clipPlaneVertexDeclaration";
import { fogVertexDeclaration } from "./ShadersInclude/fogVertexDeclaration";
import { instancesDeclaration } from "./ShadersInclude/instancesDeclaration";
import { instancesVertex } from "./ShadersInclude/instancesVertex";
import { bonesVertex } from "./ShadersInclude/bonesVertex";
import { bakedVertexAnimation } from "./ShadersInclude/bakedVertexAnimation";
import { clipPlaneVertex } from "./ShadersInclude/clipPlaneVertex";
import { fogVertex } from "./ShadersInclude/fogVertex";
import { vertexColorMixing } from "./ShadersInclude/vertexColorMixing";

const name = "colorVertexShader";
const shader = `attribute vec3 position;
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#ifdef FOG
uniform mat4 view;
#endif
#include<instancesDeclaration>
uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#ifdef VERTEXCOLOR
vec4 colorUpdated=color;
#endif
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(position,1.0);
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#include<clipPlaneVertex>
#include<fogVertex>
#include<vertexColorMixing>
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
const includes = [bonesDeclaration, bakedVertexAnimationDeclaration, clipPlaneVertexDeclaration, fogVertexDeclaration, instancesDeclaration, instancesVertex, bonesVertex, bakedVertexAnimation, clipPlaneVertex, fogVertex, vertexColorMixing];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStore[inc.name]) {
        ShaderStore.IncludesShadersStore[inc.name] = inc.shader;
    }
}

/** @internal */
export const colorVertexShader = { name, shader };
